// extracted by mini-css-extract-plugin
export default {"bb_minimalism_richtext":"richtext_bb_minimalism_richtext__zfpZU"};